import { c as _c } from "react/compiler-runtime";
import { Button, Popover, Stack, Typography } from '@mui/material';
import { type Condition } from '@repo/api-gw-sdk';
import { forwardRef, useEffect, useMemo, useRef, useState, type UIEventHandler } from 'react';
import { SelectionPanel } from '@/components/panels/selectionPanel/selectionPanel';
import { ScrollableContent } from '@/components/scroll/scrollableContent';
import { ScrollableWrapper } from '@/components/scroll/scrollableContext';
import { ScrollableHeader } from '@/components/scroll/scrollableHeader';
import { useScrollable } from '@/components/scroll/useScrollable';
import { isValueCondition, type FilterProperty, type MultiSelectConditionPanelProps } from '@/types/advanceFilter';
import { pluralize } from '@/utils/string';
import { AddValuesPanel } from '../panels/addValuesPanel';
import { MultiSelectFilter } from '../queryBuilder/filters';
import { SearchBar } from '../search/searchBar';
import { TextDetailsTuple } from '../text/textDetailsTuple';
export const inlineDropdownStyle = {
  boxShadow: 'none',
  '.MuiOutlinedInput-notchedOutline': {
    border: 0
  },
  // The outlined Select variant has no hover affordance (the theme only adds
  // one for the standard variant). These borderless inline dropdowns read as
  // buttons, so give them the same hover background as menu items / text
  // buttons.
  '&:hover': {
    backgroundColor: 'var(--mui-palette-primary-dark)'
  }
};
const ValuesFilter = props => {
  const $ = _c(56);
  const [valueFilter, setValueFilter] = useState("");
  let t0;
  if ($[0] !== props.condition) {
    t0 = isValueCondition(props.condition) && props.condition?.value || [];
    $[0] = props.condition;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectedValues = t0;
  const serverSideSearch = !!props.onSearchChange;
  let t1;
  if ($[2] !== props) {
    t1 = value => {
      setValueFilter(value);
      props.onSearchChange?.(value);
    };
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSearchChange = t1;
  let t2;
  if ($[4] !== props.options || $[5] !== serverSideSearch || $[6] !== valueFilter) {
    let t3;
    if ($[8] !== serverSideSearch || $[9] !== valueFilter) {
      t3 = option => serverSideSearch || !valueFilter || option.id.toLowerCase().includes(valueFilter.toLowerCase()) || option.name?.toLowerCase().includes(valueFilter.toLowerCase());
      $[8] = serverSideSearch;
      $[9] = valueFilter;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = props.options.filter(t3).sort();
    $[4] = props.options;
    $[5] = serverSideSearch;
    $[6] = valueFilter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const values = t2;
  const nothingToSearch = !props.isLoading && !props.options.length && !serverSideSearch;
  if (nothingToSearch && props.showAddNewButton) {
    let t3;
    if ($[11] !== props) {
      t3 = value_0 => {
        props.onChange({
          ...props.condition,
          value: value_0
        });
      };
      $[11] = props;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[13] !== props.options || $[14] !== props.shouldShowId || $[15] !== props.showNameFirst || $[16] !== props.useImagesInSelectedView) {
      t4 = item => <SelectionItem item={item} shouldShowId={props.shouldShowId} showNameFirst={props.showNameFirst} useImagesInSelectedView={props.useImagesInSelectedView} options={props.options} />;
      $[13] = props.options;
      $[14] = props.shouldShowId;
      $[15] = props.showNameFirst;
      $[16] = props.useImagesInSelectedView;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    let t5;
    if ($[18] !== props) {
      t5 = () => props.onChange({
        ...props.condition,
        value: []
      });
      $[18] = props;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    let t6;
    if ($[20] !== props || $[21] !== selectedValues) {
      t6 = item_1 => {
        const values_0 = selectedValues.filter(x => x !== item_1);
        props.onChange({
          ...props.condition,
          value: values_0
        });
      };
      $[20] = props;
      $[21] = selectedValues;
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    let t7;
    if ($[23] !== props.entityName || $[24] !== selectedValues || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
      t7 = <AddValuesPanel entityName={props.entityName} addedValues={selectedValues} onAddClick={t3} renderItem={t4} itemKey={_temp} clearAll={t5} onRemove={t6} />;
      $[23] = props.entityName;
      $[24] = selectedValues;
      $[25] = t3;
      $[26] = t4;
      $[27] = t5;
      $[28] = t6;
      $[29] = t7;
    } else {
      t7 = $[29];
    }
    return t7;
  }
  const t3 = serverSideSearch ? false : props.isLoading;
  let t4;
  if ($[30] !== props || $[31] !== selectedValues) {
    t4 = item_2 => {
      const values_1 = selectedValues.filter(x_0 => x_0 !== item_2);
      props.onChange({
        ...props.condition,
        value: values_1
      });
    };
    $[30] = props;
    $[31] = selectedValues;
    $[32] = t4;
  } else {
    t4 = $[32];
  }
  let t5;
  if ($[33] !== props.options || $[34] !== props.shouldShowId || $[35] !== props.showNameFirst || $[36] !== props.useImagesInSelectedView) {
    t5 = item_3 => <SelectionItem item={item_3} shouldShowId={props.shouldShowId} showNameFirst={props.showNameFirst} useImagesInSelectedView={props.useImagesInSelectedView} options={props.options} />;
    $[33] = props.options;
    $[34] = props.shouldShowId;
    $[35] = props.showNameFirst;
    $[36] = props.useImagesInSelectedView;
    $[37] = t5;
  } else {
    t5 = $[37];
  }
  let t6;
  if ($[38] !== props) {
    t6 = () => props.onChange({
      ...props.condition,
      value: []
    });
    $[38] = props;
    $[39] = t6;
  } else {
    t6 = $[39];
  }
  let t7;
  if ($[40] !== props.entityName || $[41] !== selectedValues || $[42] !== t4 || $[43] !== t5 || $[44] !== t6) {
    t7 = {
      items: selectedValues,
      entityType: props.entityName,
      onRemove: t4,
      renderItem: t5,
      itemKey: _temp2,
      clearAll: t6
    };
    $[40] = props.entityName;
    $[41] = selectedValues;
    $[42] = t4;
    $[43] = t5;
    $[44] = t6;
    $[45] = t7;
  } else {
    t7 = $[45];
  }
  let t8;
  if ($[46] !== handleSearchChange || $[47] !== props || $[48] !== selectedValues || $[49] !== valueFilter || $[50] !== values) {
    t8 = <ScrollableWrapper><ValuesFilterBody {...props} values={values} selectedValues={selectedValues} valueFilter={valueFilter} handleSearchChange={handleSearchChange} /></ScrollableWrapper>;
    $[46] = handleSearchChange;
    $[47] = props;
    $[48] = selectedValues;
    $[49] = valueFilter;
    $[50] = values;
    $[51] = t8;
  } else {
    t8 = $[51];
  }
  let t9;
  if ($[52] !== t3 || $[53] !== t7 || $[54] !== t8) {
    t9 = <SelectionPanel isLoading={t3} drawerProps={t7}>{t8}</SelectionPanel>;
    $[52] = t3;
    $[53] = t7;
    $[54] = t8;
    $[55] = t9;
  } else {
    t9 = $[55];
  }
  return t9;
};
const ValuesFilterBody = props => {
  const $ = _c(24);
  const {
    isScrolledVertically,
    setIsScrolledVertically
  } = useScrollable();
  let t0;
  if ($[0] !== isScrolledVertically || $[1] !== setIsScrolledVertically) {
    t0 = event => {
      const target = event.target as HTMLDivElement;
      if (typeof target.scrollTop === "number") {
        const isScrolled = target.scrollTop > 0;
        if (isScrolled !== isScrolledVertically) {
          setIsScrolledVertically(isScrolled);
        }
      }
    };
    $[0] = isScrolledVertically;
    $[1] = setIsScrolledVertically;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onScroll = t0;
  let t1;
  if ($[3] !== props.entityName) {
    t1 = pluralize(props.entityName);
    $[3] = props.entityName;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = `Select one or more ${t1}`;
  let t3;
  if ($[5] !== t2) {
    t3 = <Typography className="my-[12px]" variant="body1">{t2}</Typography>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props) {
    t4 = props.showSearchBox && <SearchBar value={props.valueFilter} setValue={props.handleSearchChange} placeholder="Search by name or ID" selectedValues={props.selectedValues} onAddClick={value => {
      props.onChange({
        ...props.condition,
        value
      });
    }} showAddButton={props.showAddNewButton} />;
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <ScrollableHeader className="px-[24px] py-[12px]">{t3}{t4}</ScrollableHeader>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== props.showAddNewButton || $[13] !== props.values.length) {
    t6 = props.values.length === 0 && <Typography variant="body1" className="my-[12px]">{props.showAddNewButton ? "No matching values found. Try a new search term, or add this value manually to include it once it\u2019s discovered." : "No matching values found. Try a new search term."}</Typography>;
    $[12] = props.showAddNewButton;
    $[13] = props.values.length;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== onScroll || $[16] !== props) {
    t7 = props.values.length > 0 && <MultiSelectFilter property={props.property} data-testid={`filter-${props.property.name}`} conditions={[props.condition]} onChange={conditions => conditions.length ? props.onChange(conditions[0]) : props.onChange({
      ...props.condition,
      value: []
    })} options={props.values} onVirtuosoScroll={onScroll} virtuosoStyles={{
      height: props.selectedValues.length ? "270px" : "330px",
      marginRight: "-24px",
      paddingRight: "24px"
    }} showNameFirst={props.showNameFirst} shouldShowId={props.shouldShowId} showSelectAll={props.showSelectAll} />;
    $[15] = onScroll;
    $[16] = props;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <ScrollableContent className="px-[24px] py-[12px]">{t6}{t7}</ScrollableContent>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
const SelectionItem = t0 => {
  const $ = _c(21);
  const {
    item,
    shouldShowId,
    showNameFirst,
    useImagesInSelectedView,
    options
  } = t0;
  let t1;
  if ($[0] !== item || $[1] !== options) {
    let t2;
    if ($[3] !== item) {
      t2 = x => x.id === item;
      $[3] = item;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = options.find(t2);
    $[0] = item;
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const option = t1;
  if (useImagesInSelectedView && option?.Image) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        overflow: "hidden",
        alignItems: "center"
      };
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== option.Image) {
      t3 = <Stack direction="row" sx={t2}>{option.Image}</Stack>;
      $[6] = option.Image;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "4px",
      overflow: "hidden"
    };
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      overflow: "hidden",
      alignItems: "center",
      gap: "12px"
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = option?.Image;
  const t5 = shouldShowId ? showNameFirst ? option?.name : option?.id : item;
  const t6 = showNameFirst ? option?.id : option?.name;
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <TextDetailsTuple primaryProp={t5} secondaryProp={t6} />;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <Stack direction="row" sx={t3}>{t4}{t7}</Stack>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== option) {
    t9 = !option && <Typography sx={{
      color: "var(--mui-palette-info-main)"
    }}>Not discovered yet</Typography>;
    $[16] = option;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <Stack sx={t2}>{t8}{t9}</Stack>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export const ConditionPanelTriggerButton = forwardRef<HTMLButtonElement, {
  selectedValues: string[];
  options: MultiSelectConditionPanelProps['options'];
  onClick: () => void;
  useImagesInSelectedView?: boolean;
  shouldShowId?: boolean;
}>((t0, ref) => {
  const $ = _c(21);
  const {
    selectedValues,
    onClick,
    options,
    useImagesInSelectedView,
    shouldShowId
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: "fit-content",
      alignItems: "start",
      gap: "8px"
    };
    t2 = <i className="material-symbols-arrow-drop-down-rounded text-xl align-middle min-w-[22px] min-h-[22px] w-[22px] h-[22px]" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== selectedValues.length) {
    t3 = selectedValues.length === 0 && <Typography variant="button" className="text-left font-medium" sx={{
      color: "var(--mui-palette-text-disabled)"
    }}>Select</Typography>;
    $[2] = selectedValues.length;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== options || $[5] !== selectedValues || $[6] !== shouldShowId || $[7] !== useImagesInSelectedView) {
    t4 = !useImagesInSelectedView && selectedValues.length > 0 && <Typography variant="button" className="text-left font-medium" sx={{
      color: "currentcolor"
    }}>{selectedValues.map(x => {
        const item = options.find(y => y.id === x);
        return item ? shouldShowId ? item?.id : item?.name : x;
      }).join(", ")}</Typography>;
    $[4] = options;
    $[5] = selectedValues;
    $[6] = shouldShowId;
    $[7] = useImagesInSelectedView;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== options || $[10] !== selectedValues || $[11] !== useImagesInSelectedView) {
    t5 = useImagesInSelectedView && selectedValues.length > 0 && <Stack direction="row" sx={{
      flexWrap: "wrap",
      columnGap: "8px",
      rowGap: "4px",
      "& > *": {
        flexShrink: 0
      }
    }}>{selectedValues.map(x_0 => options.find(y_0 => y_0.id === x_0)?.Image || x_0)}</Stack>;
    $[9] = options;
    $[10] = selectedValues;
    $[11] = useImagesInSelectedView;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <Stack direction="row-reverse" className="pl-[12px] pr-[8px]" sx={t1}>{t2}{t3}{t4}{t5}</Stack>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== onClick || $[18] !== ref || $[19] !== t6) {
    t7 = <Button ref={ref} onClick={onClick} disableFocusRipple={true} size="small" className="px-0 py-[5px] min-h-[32px] h-fit-content">{t6}</Button>;
    $[17] = onClick;
    $[18] = ref;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
});
export const MultiSelectConditionPanel = props => {
  const $ = _c(34);
  const anchorRef = useRef(null);
  const [popoverOpen, setPopoverOpen] = useState(props.popoverOpen || false);
  let t0;
  let t1;
  if ($[0] !== props.popoverOpen) {
    t0 = () => {
      if (props.popoverOpen !== undefined) {
        setPopoverOpen(props.popoverOpen);
      }
    };
    t1 = [props.popoverOpen];
    $[0] = props.popoverOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== props.condition) {
    t2 = isValueCondition(props.condition) && props.condition?.value || [];
    $[3] = props.condition;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const selectedValues = t2;
  let t3;
  if ($[5] !== props.hideButton || $[6] !== props.options || $[7] !== props.shouldShowId || $[8] !== props.useImagesInSelectedView || $[9] !== selectedValues) {
    t3 = !props.hideButton && <ConditionPanelTriggerButton ref={anchorRef} onClick={() => setPopoverOpen(true)} useImagesInSelectedView={props.useImagesInSelectedView} shouldShowId={props.shouldShowId} options={props.options} selectedValues={selectedValues} />;
    $[5] = props.hideButton;
    $[6] = props.options;
    $[7] = props.shouldShowId;
    $[8] = props.useImagesInSelectedView;
    $[9] = selectedValues;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = props.anchorRef || anchorRef;
  let t5;
  if ($[11] !== props) {
    t5 = () => {
      setPopoverOpen(false);
      props.onClose?.();
    };
    $[11] = props;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = !!props.shouldShowId;
  const t7 = !!props.showNameFirst;
  const t8 = !!props.showSelectAll;
  let t9;
  if ($[13] !== popoverOpen || $[14] !== props.condition || $[15] !== props.entityName || $[16] !== props.isLoading || $[17] !== props.onChange || $[18] !== props.onSearchChange || $[19] !== props.options || $[20] !== props.property || $[21] !== props.showAddNewButton || $[22] !== props.showSearchBox || $[23] !== props.useImagesInSelectedView || $[24] !== selectedValues || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
    t9 = <ValuesConditionPanelPopover showAddNewButton={props.showAddNewButton} showSearchBox={props.showSearchBox} property={props.property} entityName={props.entityName} isLoading={props.isLoading} options={props.options} condition={props.condition} anchorRef={t4} popoverOpen={popoverOpen} selectedValues={selectedValues} onChange={props.onChange} onClose={t5} shouldShowId={t6} showNameFirst={t7} showSelectAll={t8} useImagesInSelectedView={props.useImagesInSelectedView} onSearchChange={props.onSearchChange} />;
    $[13] = popoverOpen;
    $[14] = props.condition;
    $[15] = props.entityName;
    $[16] = props.isLoading;
    $[17] = props.onChange;
    $[18] = props.onSearchChange;
    $[19] = props.options;
    $[20] = props.property;
    $[21] = props.showAddNewButton;
    $[22] = props.showSearchBox;
    $[23] = props.useImagesInSelectedView;
    $[24] = selectedValues;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t3 || $[32] !== t9) {
    t10 = <>{t3}{t9}</>;
    $[31] = t3;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};
const ValuesConditionPanelPopover = props => {
  const $ = _c(27);
  const [isReady, setIsReady] = useState(false);
  let t0;
  let t1;
  if ($[0] !== props.popoverOpen) {
    t0 = () => {
      if (props.popoverOpen) {
        setTimeout(() => setIsReady(true), 100);
      } else {
        setIsReady(false);
      }
    };
    t1 = [props.popoverOpen];
    $[0] = props.popoverOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== props) {
    t2 = () => props.onClose();
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isReady || $[6] !== props.condition || $[7] !== props.entityName || $[8] !== props.isLoading || $[9] !== props.onChange || $[10] !== props.onSearchChange || $[11] !== props.options || $[12] !== props.property || $[13] !== props.shouldShowId || $[14] !== props.showAddNewButton || $[15] !== props.showNameFirst || $[16] !== props.showSearchBox || $[17] !== props.showSelectAll || $[18] !== props.useImagesInSelectedView) {
    t3 = isReady && <ValuesFilter showAddNewButton={props.showAddNewButton} showSearchBox={props.showSearchBox} property={props.property} entityName={props.entityName} isLoading={props.isLoading} options={props.options} condition={{
      ...props.condition
    }} onChange={props.onChange} showNameFirst={props.showNameFirst} shouldShowId={props.shouldShowId} showSelectAll={props.showSelectAll} useImagesInSelectedView={props.useImagesInSelectedView} onSearchChange={props.onSearchChange} />;
    $[5] = isReady;
    $[6] = props.condition;
    $[7] = props.entityName;
    $[8] = props.isLoading;
    $[9] = props.onChange;
    $[10] = props.onSearchChange;
    $[11] = props.options;
    $[12] = props.property;
    $[13] = props.shouldShowId;
    $[14] = props.showAddNewButton;
    $[15] = props.showNameFirst;
    $[16] = props.showSearchBox;
    $[17] = props.showSelectAll;
    $[18] = props.useImagesInSelectedView;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== t3) {
    t4 = <Stack className="w-[308px]">{t3}</Stack>;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== props.anchorRef.current || $[23] !== props.popoverOpen || $[24] !== t2 || $[25] !== t4) {
    t5 = <Popover open={props.popoverOpen} anchorEl={props.anchorRef.current} onClose={t2}>{t4}</Popover>;
    $[22] = props.anchorRef.current;
    $[23] = props.popoverOpen;
    $[24] = t2;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};
function _temp(item_0) {
  return item_0;
}
function _temp2(item_4) {
  return item_4;
}